import styled from 'styled-components'
import { theme } from '../styles/GlobalStyle'

const FunctionsStyle = styled.div`
  padding: 6.3vw 0;

  display: flex;
  justify-content: center;

  .container {
    max-width: 990px;
  }

  .nav-flex {
    list-style-type: none;
    display: flex;
    justify-content: space-between;
    padding: 0;
    margin-bottom: 60px;
    -moz-box-shadow: inset 0 -3px 3px -3px ${theme.border};
    -webkit-box-shadow: inset 0 -3px 3px -3px ${theme.border};
    box-shadow: inset 0 -3px 3px -3px ${theme.border};
  }
  .nav-flex li {
    height: 72px;
    padding: 0 8px;
  }

  .nav-flex li:hover,
  .nav-flex li.active {
    border-bottom: 3px solid ${theme.green};
    cursor: pointer;
    outline: none;
  }
  .nav-flex li:hover > h3,
  .nav-flex li.active > h3 {
    color: ${theme.green};
  }

  h3 {
    font-size: 37px;
    font-weight: 300;
    line-height: 1.73;
    color: ${theme.slateDark};
  }
  h4 {
    font-size: 24px;
    font-weight: 300;
    line-height: 1.5;
    color: ${theme.slateDark};
  }

  p {
    font-size: 14px;
    line-height: 1.71;
    color: black;
    opacity: 0.6;
  }

  p:first-child {
    padding: 8px 0;
  }
  p:last-child {
    padding: 0 0 48px;
  }

  @media (max-width: 820px) {
    .container {
      display: none;
    }
    .container-xs {
      display: block;
      text-align: center;
      padding: 0 20px;
    }

    h3 {
      padding-bottom: 5.3vw;
    }
  }
  @media (max-width: 640px) {
    h3 {
      font-size: 32px;
    }
    h4 {
      font-size: 20px;
    }
  }
  @media (max-width: 480px) {
    h3 {
      font-size: 20px;
    }
    h4 {
      font-size: 16px;
    }
  }
  @media (min-width: 821px) {
    .container {
      display: block;
    }
    .container-xs {
      display: none;
    }
  }
`
export default FunctionsStyle
